<template>
  <select-base
    v-model="value"
    class="estado-select"
    :name="'estado'"
    :class="!label ? 'remove-label' : ''"
    :disabled="disabled"
    :require="require_"
    :invalido="invalido"
    :multiple="multiple"
    :label-select="'sigla'"
    :carregar="carregarEstados"
    @input="enviarParaPai"
  />
</template>

<style lang="scss">
.remove-label .form-group {
  margin-bottom: 0;
}

.estado-select {
  min-width: 6rem !important;
}
</style>

<script>
import api from './api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'EstadosSelect',
  components: {
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    require: {
      type: Boolean,
      default: false,
    },
    invalido: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => { },
    },
    except: {
      type: Array,
      default: () => [],
    },
    externo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value_: {},
      filtros: [
        {
          coluna: 'Sigla',
          valor: '',
          soletrado: true,
        },
      ],
    }
  },
  computed: {
    require_: {
      get() {
        return this.require
      },
    },
    exceptIds: {
      get() {
        return this.except.map(map => map.id)
      },
    },
    valueInner: {
      set(value) {
        // eslint-disable-next-line no-underscore-dangle
        this.value_ = value
      },
      get() {
        // eslint-disable-next-line no-underscore-dangle
        return this.value_
      },
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    carregarEstados(filtros) {
      return new Promise((resolve, reject) => {
        api.getEstadosResumidos(filtros, this.externo)
          .then(payload => {
            if (this.except && this.except.length > 0) {
              resolve({ data: payload.data.filter(filter => !this.exceptIds.includes(filter.id)) })
            } else {
              resolve(payload)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    enviarParaPai() {
      // this.$emit('input', this.valueInner)
      this.$emit('input', this.value)
    },
  },
}
</script>
